__turbopack_context__.v({
  "root": "style-module-scss-module__B3lsUa__root",
});
